<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="功能名称：" prop="name">
                    <el-input v-model.trim="form.name" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="路由路径：" prop="route">
                    <el-input v-model.trim="form.route" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="所属菜单：" prop="menu_id">
                    <el-select v-model="form.menu_id" placeholder="请选择" clearable filterable>
                        <el-option v-for="item in menuList" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="text-align: right;margin-bottom: 8px;">
            <el-button type="primary" size="small" @click="add">新建</el-button>
        </div>
        <el-table :data="list" size="mini">
            <el-table-column label="功能名称">
                <template v-slot="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="所属菜单">
                <template v-slot="scope">
                    <span>{{ getMenuName(scope.row.menu_id) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="接口路径">
                <template v-slot="scope">
                    <span>{{ scope.row.route }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="340px">
                <template v-slot="scope">
                    <el-button type="info" size="mini" class="btnClass" @click="edit(scope.row)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="del(scope.row)">删除</el-button>
                    <i style="font-weight: 700" class="el-icon-top sort" @click="menuSort(scope.row, 2)"></i>
                    <i style="font-weight: 700" class="el-icon-bottom sort" @click="menuSort(scope.row, 1)"></i>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
        <el-dialog v-model="addVisible" :title="isEdit ? '编辑功能' : '新增功能'" width="550px">
            <el-form ref="addFormRef" :model="addForm" size="small" label-width="110px" :rules="addRules">
                <el-form-item label="所属菜单：" prop="menu_id">
                    <el-select v-model="addForm.menu_id" placeholder="请选择" clearable filterable>
                        <el-option v-for="item in menuList" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="功能名称：" prop="name">
                    <el-input v-model="addForm.name" autocomplete="off" />
                </el-form-item>
                <el-form-item label="接口路径：" prop="route">
                    <el-input v-model="addForm.route" autocomplete="off" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button size="small" @click="addVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="update(addFormRef)">
                        确认
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import util from '../../../../util/util'
import api from '../../../../axios/api'
import dayjs from 'dayjs'

export default {
    setup() {
        const form = reactive({
            name: '',
            route: '',
            menu_id: ''
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const list = ref([])
        const addVisible = ref(false)
        const addForm = reactive({
            name: '',
            menu_id: '',
            route: ''
        })
        const addFormRef = ref()
        const addRules = reactive({
            name: [
                { required: true, message: '请输入功能名称', trigger: 'blur' }
            ],
            menu_id: [
                { required: true, message: '请选择所属菜单', trigger: 'change' }
            ],
            route: [
                { required: true, message: '请输入路由路径', trigger: 'blur' }
            ]
        })
        const partnerList = ref([])
        const isEdit = ref(false)
        const menuList = ref([])

        const getMenuName = (id) => {
            const menu = menuList.value.find(item => item.id === id)
            return menu ? menu.title : ''
        }

        const getMenuList = async () => {
            const res = await api.SalesPartnerPermissionMenuList({ page: 1, limit: 1000 })
            if (res.data.code === 200) {
                menuList.value = res.data.data.data
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const onSearch = async () => {
            const res = await api.SalesPartnerPermissionFunctionList({
                ...toRaw(form),
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { data, page_info } = res.data.data
                list.value = data
                pagination.total = page_info.total
                pagination.page = page_info.current_page
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const add = () => {
            addVisible.value = true
            isEdit.value = false
            addForm.name = ''
            addForm.menu_id = ''
            addForm.route = ''
            delete addForm.id
            addFormRef.value?.clearValidate()
        }

        const edit = (row) => {
            addVisible.value = true
            addForm.name = row.name
            addForm.menu_id = row.menu_id
            addForm.route = row.route
            addForm.id = row.id
            isEdit.value = true
            addFormRef.value?.clearValidate()
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        const update = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    try {
                        const apiMethod = isEdit.value ? api.SalesPartnerPermissionFunctionUpdate : api.SalesPartnerPermissionFunctionCreate
                        const res = await apiMethod(toRaw(addForm))
                        if (res.data.code == 200) {
                            ElMessage.success('成功')
                            addVisible.value = false
                            onSearch()
                        } else {
                            ElMessage.error(res.data.msg)
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const del = (row) => {
            ElMessageBox.confirm('你确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const res = await api.SalesPartnerPermissionFunctionDelete({
                        id: row.id
                    })
                    if (res.data.code == 200) {
                        ElMessage.success('删除成功')
                        onSearch()
                    } else {
                        ElMessage.error('删除失败' + res.data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    ElMessage.info('已取消删除')
                })
        }

        const menuSort = async (row, direction) => {
            const res = await api.SalesPartnerPermissionFunctionChangeOrder({
                id: row.id,
                action: direction
            })
            if (res.data.code == 200) {
                ElMessage.success('排序成功')
                onSearch()
            } else {
                ElMessage.error('排序失败' + res.data.msg)
            }
        }

        onMounted(() => {
            getMenuList()
            onSearch()
        })

        return {
            form,
            onSearch,
            list,
            formRef,
            pagination,
            handleCurrentChange,
            add,
            resetForm,
            util,
            dayjs,
            addVisible,
            addForm,
            addRules,
            partnerList,
            addFormRef,
            update,
            edit,
            isEdit,
            del,
            menuList,
            getMenuList,
            getMenuName,
            menuSort
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
        padding-left: 16px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }
  .sort {
    font-size: 16px;
    margin: 0 5px;
    cursor: pointer;
    font-weight: 700px!important;
  }
}
</style>
